import { render, staticRenderFns } from "./token-expiration-warning.vue?vue&type=template&id=61535ae2&scoped=true"
import script from "./token-expiration-warning.vue?vue&type=script&lang=js"
export * from "./token-expiration-warning.vue?vue&type=script&lang=js"
import style0 from "./token-expiration-warning.vue?vue&type=style&index=0&id=61535ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61535ae2",
  null
  
)

export default component.exports